<template>
  <transition type="animation" 
    appear
    enter-active-class="animate__animated animate__fadeIn"
    mode="in-out"
  >
    <div v-if="temPermissao('segmento-infantil')" class="main" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" class="mt-1 mb-1" v-for="(material, index) in lists" :key="index">
              <router-link
                :to="{
                  name: 'render-conteudo-exclusivo',
                  params: { paramsForUrl: material.LinkFree || '', nomeApostila: material.title || '' },
                  query: { material: formatParam(material.description) }
                }"
              >
                <b-card no-body class="p-3 border-light card_sistemacpv">
                  <div class="d-flex align-items-center">
                    <i class="fa-light fa-book fa-xl mr-2"></i>
                    <span>{{ material.title }}</span>
                  </div>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'EDUCAÇÃO INFANTIL',
      pageSubtitle: 'Infantil 3 (Maternal II)',
      NamePermission: '',
      IndexPermission: '',

      lists: [
        {
          // 'infantil/colecao/infantil-3-maternal-2/,
          /** Descobrindo */
          linkReaOnly: '',
          LinkFree: 'infantil/colecao/infantil-3-maternal-2/ed-infantil-3-cad-1_versao-2021-web.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil_primeiraDescoberta.png',
          bundle: 'F_INFANTIL',
          title: 'Coleção Experimentando - Infantil 3 - Caderno 1',
          segment: 'S_MATERNAL2',
          discipline: '',
          description: 'Coleção Descobrindo Infantil-3-Caderno 1',
          toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 2',
          isbn: 'PROG-0001',
        },
        {
          linkReaOnly: '',
          LinkFree: 'infantil/colecao/infantil-3-maternal-2/ed-infantil-3-maternal-ii-cad-2.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil_primeiraDescoberta.png',
          bundle: 'F_INFANTIL',
          title: 'Coleção Experimentando - Infantil 3 - Caderno 1',
          segment: 'S_MATERNAL2',
          discipline: '',
          description: 'Coleção Descobrindo Infantil-3-Caderno 2',
          toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 2',
          isbn: 'PROG-0002',
        },
        {
          linkReaOnly: '',
          LinkFree: 'infantil/colecao/infantil-3-maternal-2/educacao-Infantil-3-Ingles.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil_primeiraDescoberta.png',
          bundle: 'F_INFANTIL',
          title: 'Coleção Descobrindo - Infantil 3 - Inglês',
          segment: 'S_MATERNAL2',
          discipline: 'Língua Inglesa',
          description: 'Coleção Descobrindo Infantil-3-Inglês',
          toolTip: '',
          isbn: 'ISBN:978-85-8451-006-1',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },
  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}
</style>
